import { type ReactNode, useCallback, useState } from "react";
import type { ApiError } from "../../../api/ApiClient";
import { ProgressBarContext } from "./ProgressBarContext";
import {
  HeaderWithProgressContext,
  type Reset,
} from "./HeaderWithProgressContext";

class SavingFlag {}

export function HeaderWithProgressProvider({
  children,
}: {
  children: ReactNode;
}) {
  const defaultProgress = 1;

  const [savingFlags, setSavingFlags] = useState<SavingFlag[]>([]);
  const [progress, setProgress] = useState(defaultProgress);
  const [hasSaved, setHasSaved] = useState(false);
  const [saveError, setSaveError] = useState<ApiError | null>(null);

  const setIsSaving = useCallback(() => {
    const flag = new SavingFlag();

    setSavingFlags((prev) => [...prev, flag]);

    const reset: Reset = () => {
      setSavingFlags((prev) => prev.filter((x) => x !== flag));
      // Set hasSaved to true when at least one save operation is completed.
      // If other things are still saving then both isSaving and hasSaved will be true.
      // When all save operations are completed, isSaving will be false and hasSaved will be true, which will show "Lagret!" in the header.
      setHasSaved(true);
    };

    return reset;
  }, []);

  const isSaving = savingFlags.length > 0;

  return (
    <HeaderWithProgressContext.Provider
      value={{
        isSaving,
        setIsSaving,
        hasSaved,
        saveError,
        setSaveError,
        progress,
      }}
    >
      <ProgressBarContext.Provider value={{ setProgress }}>
        {children}
      </ProgressBarContext.Provider>
    </HeaderWithProgressContext.Provider>
  );
}
